/* unplugin-vue-components disabled */import script from "./HomeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeView.vue?vue&type=script&lang=ts&setup=true"

import "./HomeView.vue?vue&type=style&index=0&id=bc3bbc88&lang=less&scoped=true"
import "./HomeView.vue?vue&type=style&index=1&id=bc3bbc88&lang=css"

import exportComponent from "/Users/neo/Desktop/SynologyDrive/2.gitee/NeoCharming/zangyu/fenci/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.47+webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc3bbc88"]])

export default __exports__